export default __webpack_public_path__ + "static/media/gridicons_filter.d6af7f30.svg";